import {
  Component,
  Input,
  OnChanges,
  OnInit,
  OnDestroy,
  SimpleChanges,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { environment } from "src/environments/environment";
import { Router, RouterModule } from "@angular/router";
import { SafePipe } from "src/app/shared/pipes/safe.pipe";
import { TypeofPipe } from "src/app/shared/pipes/typeof.pipe";
import { LocalizationModule } from "../localization";
import { SafeTypes } from "src/app/shared/constants/safe-types.enum";
import { ApplicationService } from "../../shared/constants/application.service";
import { TranslocoService } from "@ngneat/transloco";
import { Store } from "@ngxs/store";
import { UserState } from "src/app/store/user/user.store";
import { Subscription } from "rxjs";
import { StudiosService } from "src/app/shared/constants/studios.service";

@Component({
  selector: "app-header",
  standalone: true,
  imports: [
    CommonModule,
    LocalizationModule,
    RouterModule,
    TypeofPipe,
    SafePipe,
  ],
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit, OnChanges, OnDestroy {
  @Input() aauSubdomain: boolean = false;
  @Input() isDiffUrl!: boolean;
  currentLang: string = "en";

  subscriptions: Subscription[] = [];

  jkfSubdomain: boolean | null = null;
  owtmaSubdomain: boolean | null = null;
  hasStudios: boolean | null = null;

  constructor(
    public router: Router,
    private applicationService: ApplicationService,
    private store: Store,
    private transloco: TranslocoService,
    private studiosService: StudiosService
  ) {}

  public SafeTypes = SafeTypes;
  public baseUrl = environment.BASEURL.slice(
    environment.BASEURL.indexOf("/") + 2,
    -1
  );

  public menu: any = [
    {
      name: "HOME",
      link: "/",
      show: true,
      exact: true,
    },
    {
      name: "EVENTS",
      link: "/events",
      show: true,
    },
    {
      name: "STUDIOS",
      link: "/hub-studios",
      show: true,
    },
    {
      name: "",
      type: "sep",
      show: false,
    },
    {
      name: "RANKINGS",
      link: "/rankings",
      show: true,
    },
    {
      name: "STORE",
      link: "/store/list",
      show: true,
    },
    {
      name: "TV",
      link: "https://youtube.com/@Uventex/videos",
      show: true,
      outside: true,
    },
    {
      name: "ATHLETES",
      link: "/athletes",
      show: true,
    },
    {
      name: "MEMBERSHIPS",
      link: "/memberships",
      show: true,
    },
    {
      name: "NEWS",
      link: `https://www.uventexlabs.com/blog`,
      show: true,
      outside: true,
    },
  ];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["aauSubdomain"]) {
      const currentValue = changes["aauSubdomain"].currentValue;
      const previousValue = changes["aauSubdomain"].previousValue;
      if (currentValue !== previousValue) {
        this.configureUrlRanking();
        this.configureMenu();
      }
    }
  }
  ngOnInit() {
    this.subscriptions.push(
        this.applicationService.jkfSubdomain$.subscribe((jkfSubdomain) => {
          this.jkfSubdomain = jkfSubdomain;
          this.configureUrlRanking();
          this.configureMenu();
        })
    );

    this.subscriptions.push(
      this.applicationService.owtmaSubdomain$.subscribe((owtmaSubdomain) => {
        this.owtmaSubdomain = owtmaSubdomain;
        this.configureUrlRanking();
        this.configureMenu();
      })
    );

    this.subscriptions.push(
      this.studiosService.hasStudios$.subscribe((hasStudios) => {
        this.hasStudios = hasStudios;
        this.configureUrlRanking();
        this.configureMenu();
      })
    );
    this.studiosService.loadHasStudios();

    this.transloco.langChanges$.subscribe((lang) => {
      const currentLang = lang.split("-")[0];
      this.currentLang = currentLang;
      this.configureUrlRanking();
      this.configureMenu();
    });

    this.configureUrlRanking();
    this.configureMenu();
  }

  ngOnDestroy(): void {
    for (const s of this.subscriptions) {
      try {
        s.unsubscribe();
      } catch (e) {
        console.error(e);
      }
    }
  }

  configureUrlRanking() {
    let returnUrl = window.location.href;
    returnUrl = encodeURIComponent(returnUrl).replaceAll("%2F", "___");

    const authToken = this.store.selectSnapshot(UserState.authToken);
    const token = authToken && authToken.token ? authToken.token : null;

    let rankingURL = `${environment.EVENT_REPORT_URL}GWTClient.html?&locale=${this.currentLang}#rankings;applicationMode=SPORTSHUB;sportsHubUrl=${returnUrl};token=${token}`;

    if (this.jkfSubdomain) {
      rankingURL = '/rankings';
    }

    this.menu = [
      {
        name: "HOME",
        link: "/",
        show: true,
        exact: true,
      },
      {
        name: "EVENTS",
        link: "/events",
        show: true,
      },
      {
        name: "STUDIOS",
        link: "/hub-studios",
        show: this.hasStudios !== false,
      },
      {
        name: "",
        type: "sep",
        show: false,
      },
      {
        name: "RANKINGS",
        link: "/rankings",
        show: true,
      },
      {
        name: "STORE",
        link: "/store/list",
        show: true,
      },
      {
        name: "TV",
        link: "https://youtube.com/@Uventex/videos",
        show: true,
        outside: true,
      },
      {
        name: "ATHLETES",
        link: "/athletes",
        show: true,
      },
      {
        name: "MEMBERSHIPS",
        link: "/memberships",
        show: true,
      },
      {
        name: "NEWS",
        link: `https://www.uventexlabs.com/blog`,
        show: true,
        outside: true,
      },
    ];
  }

  configureMenu() {
    if (this.aauSubdomain) {
      this.menu = [
        {
          name: "EVENTS",
          link: "/events",
          show: true,
        },
        {
          name: "APPLICATIONS",
          link: "/applications",
          show: true,
        },
      ];
    } else if (this.owtmaSubdomain) {
      this.menu = this.menu.filter((m: any) =>
        ["/", "/events", "/hub-studios", "/rankings"].includes(m.link)
      );
    }
    // this.applicationService.getInfo().subscribe((response: any) => {
    //   if (response) {
    //     const league = this.menu.find(
    //       (option: any) => option.link === "/memberships"
    //     );
    //     if (league) {
    //       // league.show = !response.isSubdomain;
    //     }
    //   }
    // });
  }
}
